import { render } from "./ExamineeinfoCard.vue?vue&type=template&id=47b49aca&scoped=true"
import script from "./ExamineeinfoCard.vue?vue&type=script&lang=js"
export * from "./ExamineeinfoCard.vue?vue&type=script&lang=js"

import "./ExamineeinfoCard.vue?vue&type=style&index=0&id=47b49aca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b49aca"]])

export default __exports__